import { styled, theme } from "../../../../styles/stitches.config"

export const SContainer = styled("div", {
  "@md": {
    maxWidth: theme.sizes.s110,
  },
})
